'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { onBackButton } from '@/lib/utils/deep-linking'

/**
 * Wire Android hardware back button to Next.js router.
 *
 * - If there's history: go back
 * - If at root: minimize the app (default Capacitor behavior)
 *
 * Drop this into the dashboard shell or root layout.
 */
export function useNativeBackButton() {
  const router = useRouter()

  useEffect(() => {
    let cleanup: (() => void) | undefined

    onBackButton((canGoBack) => {
      if (canGoBack) {
        router.back()
      }
      // If canGoBack is false, Capacitor's default behavior kicks in:
      // the app minimizes (Android) — no need for us to do anything.
    }).then((fn) => {
      cleanup = fn
    })

    return () => {
      cleanup?.()
    }
  }, [router])
}
